import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  OnChanges,
  AfterViewInit
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl
} from '@angular/forms';
import { CpmService } from 'app/service/cpm.service';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';
import { SetAttendeesComponent } from '../../crm/set-attendees/set-attendees.component';
import { StatusComponent } from '../../crm/status/status.component';
import { ToastrService } from 'ngx-toastr';
import { isNullOrUndefined } from 'util';
import { AuthorizeService } from 'app/service/authorize.service';
import { Subject, Observable } from '../../../../node_modules/rxjs';
@Component({
  selector: 'app-company-ae-form-add',
  templateUrl: './company-ae-form-add.component.html',
  styleUrls: ['./company-ae-form-add.component.scss']
})
export class CompanyAeFormAddComponent
  implements OnInit, OnChanges, AfterViewInit {
  @Input()
  createFormData;
  @Output()
  onFinished: EventEmitter<any> = new EventEmitter();

  @ViewChild('template')
  template: TemplateRef<any>;
  @ViewChild('notification')
  notification: TemplateRef<any>;
  @ViewChild('setAttendeesComponent')
  setAttendeesComponent: SetAttendeesComponent;
  @ViewChild('statusComponent')
  statusComponent: StatusComponent;

  modalRef: BsModalRef;

  meetingObjectiveList: Array<Object> = [];
  securityList: Array<Object> = [];
  setEmployeeList: Array<Object> = [];

  caseForm: FormGroup = new FormGroup({});

  allAe: Array<Object> = [];
  allSecurityHasAe: Array<String> = [];
  id;

  empList = [];
  editStatus = false;
  buttonLabel;
  divisionId;
  dataLoaded;

  searchResults: Array<Object>;
  message: String = '';
  aeName: String = '';

  public keyUp = new Subject<any>();

  constructor(
    private modalService: BsModalService,
    private authorization: AuthorizeService,
    private cpmService: CpmService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.keyUp
      .map(event => {
        event.target.value = event.target.value.toUpperCase();
        this.searchResults = this.securityList
          .filter(x => x['securitySymbol'].startsWith(event.target.value))
          .slice(0, 5);
        return event.target.value;
      })
      .debounceTime(500)
      .distinctUntilChanged()
      .flatMap(search => Observable.of(search).delay(500))
      .subscribe(securitySymbol => {
        const listSymbol = this.allSecurityHasAe.find(
          x => x === securitySymbol
        );
        if (listSymbol) {
          const text = 'ตรวจพบหุ้น ' + securitySymbol + ' มี AE ดูแลอยู่แล้ว';
          this.toastr.info(text);
        }
      });

    this.createForm();
  }
  ngAfterViewInit() {}

  async getEmployee() {
    this.divisionId = this.createFormData.divisionId;

    return this.cpmService.getEmployeeList().then(obj => {
      this.setEmployeeList = obj;

      const listEmployeeByDivision = this.setEmployeeList.filter(
        obj1 => obj1['divisionId'] === this.divisionId
      );

      this.setEmployeeList = listEmployeeByDivision.map(x => {
        x['label'] = this.prepareSetEmployeeDatalist(x);
        return x;
      });
    });
  }

  async getCommonData() {
    await this.dataLoaded;
    await this.cpmService.getSecurityList().then(response => {
      this.securityList = response.map(x => {
        const responseSymbol = {};
        responseSymbol['securitySymbol'] = x.securitySymbol;
        responseSymbol['securityIdPsims'] = x.securityIdPsims;
        return responseSymbol;
      });
    });

    await this.cpmService.getAllAEList().then(success => {
      const listData = success;

      if (listData !== null) {
        this.allSecurityHasAe = [].concat
          .apply([], listData.map(x => x.security))
          .map(x => x.securitySymbol);
        this.allAe = listData;
        listData.map(obj => {
          if (obj.id === this.id) {
            obj.security.map(security => {
              const searchObj = {};
              searchObj['securitySymbol'] = [
                security.securitySymbol,
                Validators.required
              ];
              this.items.push(this.fb.group(searchObj));
            });
          }
        });
      }
    });
    const emp = this.setEmployeeList.find(empObj => empObj['id'] === this.id);
    if (emp !== undefined) {
      this.aeName = this.prepareSetEmployeeDatalist(emp);
      this.caseForm.get('name').setValue(emp);
    }
    if (isNullOrUndefined(this.id)) {
      this.editStatus = false;
      this.addItem();
      this.buttonLabel = 'Add';
    } else {
      this.editStatus = true;
      this.buttonLabel = 'Update';
    }
  }

  createForm() {
    this.caseForm = this.fb.group({
      name: ['', Validators.required],
      items: this.fb.array([])
    });
  }

  ngOnChanges() {
    if (this.dataLoaded == null) {
      this.dataLoaded = this.getEmployee();
    }
    this.id = this.createFormData.id;
    this.createForm();
    this.getCommonData();
  }

  finished() {
    this.onFinished.emit({});
  }

  addItem() {
    const searchObj = {};
    searchObj['securitySymbol'] = ['', Validators.required];
    this.items.push(this.fb.group(searchObj));
  }

  onDelete(index) {
    this.items.removeAt(index);
  }

  onClickOpenModal() {
    this.openModal(this.template);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-sm', ignoreBackdropClick: true })
    );
  }

  onDeleteAE() {
    this.modalRef.hide();
    this.cpmService.deleteAEProfile(this.id).then(
      success => {
        this.toastr.success('ลบสำเร็จแล้ว');
        this.onFinished.emit(success);
      },
      error => {
        this.toastr.error('ลบไม่สำเร็จ');
      }
    );
  }
  get items(): FormArray {
    return this.caseForm.get('items') as FormArray;
  }
  get plusItems(): Number {
    if (this.items.length > 0) {
      return (this.items.length - 1) as Number;
    } else {
      return 0;
    }
  }

  searchWithMultipleLang(term: string, item: Object) {
    const checkEnglish = /^[a-zA-Z]/.test(term);
    if (checkEnglish) {
      return (item['firstNameEng'] + ' ' + item['lastNameEng'])
        .toUpperCase()
        .startsWith(term.toUpperCase());
    } else {
      return (item['firstNameThai'] + ' ' + item['lastNameThai'])
        .toUpperCase()
        .startsWith(term.toUpperCase());
    }
  }

  prepareSetEmployeeDatalist(employeeElement) {
    return (
      employeeElement.firstNameThai +
      ' ' +
      employeeElement.lastNameThai +
      ' - ' +
      employeeElement.positionName +
      ' - ' +
      employeeElement.departmentShortName
    );
  }

  multiFilter(array, filters) {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
      // tslint:disable-next-line:no-bitwise
      return filterKeys.every(key => !!~filters[key].indexOf(item[key]));
    });
  }
  async onSubmit() {
    if (this.caseForm.valid) {
      const listValue = this.caseForm
        .get('items')
        .value.map(x => x.securitySymbol.toUpperCase())
        .map(x => {
          return this.securityList.find(
            symbol => symbol['securitySymbol'] === x
          )['securityIdPsims'];
        });
      const employeeId = this.caseForm.get('name').value.id;
      const putData = {
        id: employeeId,
        securityIdPsims: listValue
      };

      const ae = this.allAe.find(x => x['id'] === employeeId);
      if (!this.editStatus && ae) {
        this.message =
          'ไม่สามารถเพิ่มข้อมูล AE ได้เนื่องจากมีข้อมูลอยู่แล้ว กรุณาค้นหา AE เดิมเพื่ออัพเดท';
        this.openModal(this.notification);
        return;
      }

      this.cpmService.updateAEProfile(putData).then(
        success => {
          this.toastr.success('การบันทึกรายการสำเร็จแล้ว');
          this.onFinished.emit(success);
        },
        error => {
          this.toastr.error('บันทึกรายการไม่สำเร็จ');
        }
      );
    }
  }

  get isUserHasEditPermission() {
    return this.authorization.hasRole('CRM_AE_SUM');
  }

  get getUserDivision() {
    return this.authorization.getUserDivision();
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae-form-add/company-ae-form-add.component.ts